import React from 'react';
import PropTypes from 'prop-types';

import HeaderDropdown from '../headerDropdown';
import SimpleHeader from '../../headers/simpleHeader';

const IntegrationsOutlet = ({ children }) => (
  <div className="c-wrapper integrations o-flexbox o-flexbox--content-align-center o-flexbox--justify-center">
    <SimpleHeader heading="Brand Settings">
      <HeaderDropdown title="Integrations" />
    </SimpleHeader>
    {children}
  </div>
);

IntegrationsOutlet.propTypes = {
  children: PropTypes.node,
};

IntegrationsOutlet.defaultProps = {
  children: undefined,
};

export default IntegrationsOutlet;
